import { useTranslation } from "@localization/useTranslation";
import { joinAsAlternatives } from "@common/utilities";
import { PlanType } from "../auth/planProvider/PlanProvider.types";

interface LockableEntityTemplate {
    id: string;
    hasAccess: boolean;
    unlockingPlans: Array<PlanType>;
}

export function useEntityTemplateLockedText() {
    const { translateString, translatePlanType } = useTranslation();

    const getLockedText = (unlockingPlans: Array<PlanType>) => {
        const planNames = unlockingPlans.map(translatePlanType);
        return translateString("entityTemplateLockedByPlan", { plans: joinAsAlternatives(planNames, translateString("or")) });
    };

    const getLockedTextsById = (templates: Array<LockableEntityTemplate>) => {
        return new Map(templates.filter((x) => !x.hasAccess).map((x) => [x.id, getLockedText(x.unlockingPlans)]));
    };

    return { getLockedText, getLockedTextsById };
}
